import feedbackApp from './Feedback';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const feedbackConfig = {
    auth: authRoles.cc, //  ['admin']
    routes: [
        {
            path: '/apps/feedback/',
            component: feedbackApp
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/feedback/FeedbackConfig.js